import styled from 'styled-components';

import { Loading, LoadingProps } from '.';

import IconSmallLoadingSpinner from '@public/icons/spinner.svg';

type Props = Omit<LoadingProps, 'onlySpinner'> & {
  width?: string;
  height: string;
  isSmallSpinner?: boolean;
};

export function LoadingInner({ width = '100%', height, isSmallSpinner, ...loadingProps }: Props) {
  if (isSmallSpinner) {
    return (
      <StyledLoadingBox style={{ width, height }}>
        <StyledSmallLoadingSpinner>
          <IconSmallLoadingSpinner />
        </StyledSmallLoadingSpinner>
      </StyledLoadingBox>
    );
  }

  return (
    <StyledLoadingBox style={{ width, height }}>
      <Loading {...loadingProps} onlySpinner noDelay />
    </StyledLoadingBox>
  );
}
const StyledLoadingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledSmallLoadingSpinner = styled.div`
  height: 100px;
  width: 100px;
`;
